import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 支払済のENUM */
enum PaidType {
  /** 未 */
  notYet = '1',
  /** 済 */
  completed = '2',
}

const nameConfig = {
  notYet: new Map([[Locale.ja, '未']]),
  completed: new Map([[Locale.ja, '済']]),
};

const toEnum = rawValueToEnum(PaidType, PaidType.notYet);
const toDisplay = enumToName(PaidType, nameConfig);
const toDisplayWithPrefix = enumToName(PaidType, nameConfig, { prefix: true });

export const paidType = {
  enum: PaidType,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { PaidType };
